import { CartesianGrid, YAxis, LineChart, XAxis, Line } from "recharts";

import { getChartColor, prepareChartData } from "../helpers/functions";

export default function StandardLineChart({ chart, children }) {
  const { data, dimensions, measures } = prepareChartData(chart);
  return (
    <LineChart data={data}>
      <CartesianGrid />
      {dimensions.map((axis) => (
        <XAxis dataKey={axis?.data_key} key={axis?.data_key} />
      ))}

      <YAxis />
      {measures.map((measure, idx) => (
        <Line
          type="monotone"
          dataKey={measure?.data_key}
          key={`${measure?.data_key}_${idx}`}
          name={measure?.label}
          stroke={getChartColor(idx)}
        />
      ))}
      {children}
    </LineChart>
  );
}
